export function inputStringToNumber(value: string): number {
  const negativeCorrectedValue = value.replace('\u2212', '\u002d');
  const parsedValue = parseInt(negativeCorrectedValue);
  return isNaN(parsedValue) ? 0 : parsedValue;
}
